// extracted by css-extract-rspack-plugin
export default {"container":"IssuesLoadingSkeleton-module__container__KyHN_"};